import { render, staticRenderFns } from "./payslip-footer.vue?vue&type=template&id=e26ea9f2&scoped=true&"
import script from "./payslip-footer.vue?vue&type=script&lang=js&"
export * from "./payslip-footer.vue?vue&type=script&lang=js&"
import style0 from "./payslip-footer.vue?vue&type=style&index=0&id=e26ea9f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e26ea9f2",
  null
  
)

export default component.exports